const calculator = {
  calculator: {
    pageTitle: 'Calculator',
    pageDescription: '분당 요금을 기준으로, 예상 사용료를 USD와 KRW로 간편하게 계산하세요.',

    label: {
      currency: '통화',
      planType: '요금제 유형',
      pricePerMin: '분당 요금',
      usagePeriod: '사용 시간 (분 단위)',
      totalEstimatedCost: '예상 총 요금'
    },

    button: {
      moreInfo: '문의하기',
      reset: '초기화'
    },

    plan: {
      pass: 'PASS 플랜'
    },

    country: {
      1: '대한민국',
      2: '국가 2',
      3: '국가 3',
      4: '국가 4'
    },

    currency: {
      1: 'KRW',
      2: 'USD'
    },

    perMinute: {
      1: '$13',
      2: '$15',
      3: '$17',
      4: '$19'
    }
  }
};

export default calculator;
